import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'modal-usage',
  templateUrl: './modal-usage.component.html',
  styleUrls: ['./modal-usage.component.sass']
})
export class ModalUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
